import React from 'react';

import Layout, { ContentSection } from '../components/Layout';
import HeaderButtonMenu from '../components/home/HeaderButtonMenu';

function NotFoundPage() {
  return (
    <Layout title='Page Not Found - VoteAmerica'>
      <ContentSection width='mid'>
        <h1>Page not found</h1>
        <p>
          The page you requested does not exist. Were you looking for some of
          our tools?
        </p>
        <HeaderButtonMenu
          tools={[
            'verify',
            'register',
            'absentee',
            'upcoming',
            'futurevoter',
            'remind',
            'pav',
            'locate',
            'trackMail',
            'trackProvisional',
            'leo',
          ]}
        />
      </ContentSection>
    </Layout>
  );
}

export default NotFoundPage;
